import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import Company from '../model/company/company';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { CollectionHelper } from '../helpers/collection-helper';

@Injectable({
  providedIn: 'root'
})
export class ClientCompanySelectService {
  private selectableCompanies = new BehaviorSubject<Company[]>(null);
  private selectedCompany: Company;
  private companySelectionChanged: Subject<Company> = new ReplaySubject<
    Company
  >(1);

  constructor(private requestService: RequestService) {}

  public fetchSelectableCompanies(): void {
    this.selectableCompanies.next(null);
    this.selectCompany(null);
    this.requestService
      .get('/companies/my-client-access')
      .toPromise()
      .then((companiesRes: { body: Company[] }) => {
        this.selectableCompanies.next(companiesRes.body);
        if (companiesRes.body.length >= 1) {
          const localStorageLastSelectedCompanyId = localStorage.getItem(
            'lastSelectedCompanyId'
          );
          const lastSelectedCompany =
            localStorageLastSelectedCompanyId == null
              ? null
              : companiesRes.body.find(
                  c => c.id === Number(localStorageLastSelectedCompanyId)
                );
          this.selectCompany(
            lastSelectedCompany == null
              ? companiesRes.body[0]
              : lastSelectedCompany
          );
        }
      });
  }

  public getSelectableCompanies(): Company[] {
    return this.selectableCompanies.value;
  }

  public getSelectableCompaniesSubscribable(): Observable<Company[]> {
    return this.selectableCompanies;
  }

  public selectCompany(company: Company, hasCompanies = true): void {
    if (!hasCompanies) {
      localStorage.setItem('lastSelectedCompanyId', '');
      localStorage.setItem('lastSelectedPendingInvoices', 'false');
      this.selectedCompany = null;
      this.companySelectionChanged.next(this.selectedCompany);
    } else {
      if (company != null && company.id != null) {
        localStorage.setItem('lastSelectedCompanyId', company.id.toString());
      }
      if (this.selectedCompany !== company) {
        this.selectedCompany = company;
        this.companySelectionChanged.next(this.selectedCompany);
        localStorage.setItem(
          'lastSelectedPendingInvoices',
          this.selectedCompany != null
            ? this.selectedCompany.pendingInvoices.toString()
            : 'false'
        );
      }
    }
  }

  public trySelectCompany(id: number): void {
    if (!CollectionHelper.isPopulated(this.selectableCompanies.value)) {
      return;
    }

    const matchingCompany = this.selectableCompanies.value.find(
      c => c.id === id
    );
    if (matchingCompany != null) {
      this.selectCompany(matchingCompany);
    }
  }

  public getSelectedCompany(): Company {
    return this.selectedCompany;
  }

  public getSelectedCompanyId(): number {
    const id: number = +localStorage.getItem('lastSelectedCompanyId');

    return id;
  }

  public getSelectionChangedSubscribable(): Subject<Company> {
    return this.companySelectionChanged;
  }

  public resetSelectableCompanies(hasCompanies = true): void {
    this.selectableCompanies.next(null);
    this.selectCompany(null, hasCompanies);
  }
}
